import { useEffect, useState } from 'react'
import { DefaultWithTitleLayout } from '../../components/templates/default-with-title-layout'
import { VixellTable } from '../../components/part/vixell-table'
import { NewButton } from '../../components/part/new-button'
import { SquareButton } from '../../components/molecules/sqare-button'
import { ConfirmModal } from '../../components/part/ConfirmModal'
import { Lang } from '../../translations/lang'
import { webRequest } from '../../types/handle-api'
import { RfidDeviceValidPeriodComponent } from '../../types/typescript-axios'
import { CreateRfidDeviceValidPeriod } from '../../components/templates/in-hospital/create-rfid-device-valid-period'
import { EditRfidDeviceValidPeriod } from '../../components/templates/in-hospital/edit-rfid-device-valid-period'

// RFID 機器有効期間マスタ管理（T-003）。
// 仕様: screens.md / data-models.md §5。CRUD は id ベース（MR-004=案1）。
export const RfidDeviceValidPeriods = () => {
  const [items, setItems] = useState<RfidDeviceValidPeriodComponent[]>([])

  const [showCreateModal, setShowCreateModal] = useState<boolean>(false)
  const [editTarget, setEditTarget] = useState<RfidDeviceValidPeriodComponent>()
  const [destroyTarget, setDestroyTarget] =
    useState<RfidDeviceValidPeriodComponent>()

  async function fetchData() {
    const response = await webRequest('RfidDeviceValidPeriodIndex')
    if (response.status === 200) {
      setItems(response.data.items)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  async function destroy() {
    if (!destroyTarget) return
    const response = await webRequest('RfidDeviceValidPeriodDestroy', {
      id: destroyTarget.id,
    })
    if (response.status === 200) {
      setDestroyTarget(undefined)
      fetchData()
    }
  }

  const titleRightElement = (
    <div>
      <NewButton onClick={() => setShowCreateModal(true)} />
    </div>
  )

  return (
    <DefaultWithTitleLayout
      title={Lang.inHospital.validPeriod.title}
      description={Lang.inHospital.validPeriod.description}
      titleRightElement={titleRightElement}
    >
      <VixellTable
        rootClassName="my-64"
        classNames={[
          'w-260',
          'w-200',
          'w-200',
          'flex-1 !justify-end pr-[42px]',
        ]}
        headers={[
          Lang.inHospital.validPeriod.macAddress,
          Lang.inHospital.validPeriod.startDate,
          Lang.inHospital.validPeriod.endDate,
          '',
        ]}
        elements={items.map((item) => [
          item.macAddress,
          item.startDate,
          item.endDate,
          <div key={item.id} className="flex gap-[12px]">
            <SquareButton color="blue" onClick={() => setEditTarget(item)}>
              {Lang.edit}
            </SquareButton>
            <SquareButton color="red" onClick={() => setDestroyTarget(item)}>
              {Lang.delete}
            </SquareButton>
          </div>,
        ])}
      />
      {showCreateModal && (
        <CreateRfidDeviceValidPeriod
          hide={() => setShowCreateModal(false)}
          onSaved={() => {
            setShowCreateModal(false)
            fetchData()
          }}
        />
      )}
      {editTarget && (
        <EditRfidDeviceValidPeriod
          target={editTarget}
          hide={() => setEditTarget(undefined)}
          onSaved={() => {
            setEditTarget(undefined)
            fetchData()
          }}
        />
      )}
      {destroyTarget && (
        <ConfirmModal
          title={Lang.inHospital.validPeriod.confirmDelete}
          ok={destroy}
          cancel={() => setDestroyTarget(undefined)}
        />
      )}
    </DefaultWithTitleLayout>
  )
}
